module.exports = __webpack_public_path__ + "static/man-a-ad1bc78b9027a4e10afb59c5f8c6c0d4.jpg";